export function animateWishlistIcon() {
  const heartIcon = document.querySelector(".heart-icon-btn-container");

  if (!heartIcon) return;

  heartIcon.classList.add("wishlist-item-added");

  setTimeout(() => {
    heartIcon.classList.remove("wishlist-item-added");
  }, 2000);
}

export function animateItemCounter(className) {
  const iconCounter = document.querySelector(className);

  if (!iconCounter) return;

  iconCounter.classList.add("item-added");

  setTimeout(() => {
    iconCounter.classList.remove("item-added");
  }, 1000);
}
